import axios from 'axios';

const axiosServices = axios.create({ baseURL: import.meta.env.VITE_APP_API_URL });

// ==============================|| AXIOS - FOR MOCK SERVICES ||============================== //

axiosServices.interceptors.request.use(
  async (config) => {
    const accessToken = localStorage.getItem('token') || localStorage.getItem('accessToken');
    if (accessToken) {
      config.headers['Authorization'] = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosServices.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 403) {
      return Promise.reject(error.response?.data || 'Wrong Services');
    }
    return Promise.reject(error);
  }
);

export default axiosServices;

export async function fetcher(args) {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosServices.get(url, { ...config });

  return res.data;
}

export const fetchYoutubeChannels = async () => {
  const response = await axiosServices.get('/youtube/channels');
  return response.data;
};

export const fetchYoutubeAds = async () => {
  const response = await axiosServices.get('/youtube/ads');
  return response.data;
};
